/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SecurityIssuedIn {
    UNITS = 'UNITS',
    CURRENCY = 'CURRENCY',
}
